import $ from 'jquery'
import Swup from 'swup'

import SwupBodyClassPlugin from '@swup/body-class-plugin'

export const Events = {
    ClickLink: 'swup:clicklink',
    WillReplaceContent: 'swup:willreplacecontent',
    ContentReplaced: 'swup:contentreplaced',
}

export function runSwup({
    Nette,
    EventBus,
    ScrollService,
    scrollToElement,
    loadComponents,
    removeComponents,
    scrollHistory,
    setScrollPosition,
    runScriptsInsideElement,
    isNativeScroll,
}) {
    if (
        !Nette ||
        !EventBus ||
        !ScrollService ||
        !scrollToElement ||
        !loadComponents ||
        !removeComponents ||
        !scrollHistory ||
        !setScrollPosition ||
        !runScriptsInsideElement ||
        !isNativeScroll
    ) {
        console.error('Dependencies required to run swup')
        return
    }

    const linkSelector =
        'a' +
        [
            '[href^="#"]',
            '[href^="http"]',
            '[href^="/files"]',
            '[href^="/data"]',
            '[data-no-swup]',
            '[data-ajax-append]',
            '[target="_blank"]',
            '.ajax',
            '[href^="mailto"]',
            '[href^="tel"]',
            // javascript: odkazy nejsou navigace (např. tlačítka CKEditoru)
            '[href^="javascript"]',
            '[data-component]',
        ]
            .map(selector => `:not(${selector})`)
            .join('')

    const swup = new Swup({
        linkSelector,
        containers: [
            '#page-content',
            '#header-navigation',
            '#footer',
            '#modals',
        ],
        animationSelector: '.PageTransition',
        plugins: [new SwupBodyClassPlugin()],
        skipPopStateHandling: () => false,
    })

    swup.hooks.on('link:click', event => {
        EventBus.emit(Events.ClickLink, { event })
        scrollHistory.saveCurrent()
    })

    swup.hooks.on('visit:start', visit => {
        const els = [...document.querySelectorAll(visit.containers.join(','))]
        els.forEach(element => {
            removeComponents(element)
        })
    })

    swup.hooks.on('link:self', () => {
        scrollToElement(document.querySelector('.Header'), {
            mode: 'force',
        })
    })

    swup.hooks.on('content:replace', visit => {
        if (isNativeScroll()) {
            ScrollService.useNative()
        } else {
            ScrollService.useVirtual().catch(() => ScrollService.useNative())
        }
        Nette.reinit()

        // znovu navázat jquery.nette.ajax na nové .ajax odkazy (init váže přímo na elementy, ne delegovaně)
        // jinak by AJAX odkazy (např. paginace „Načíst další") po swup navigaci dělaly full reload
        if ($.nette && $.nette.load) {
            $.nette.load()
        }

        const elements = [...document.querySelectorAll(visit.containers.join(','))]
        elements.forEach(element => {
            loadComponents(element)
        })

        if (ScrollService) {
            ScrollService.resize()

            const historyState = scrollHistory.getCurrent()
            if (historyState) {
                setScrollPosition(historyState.scroll.x, historyState.scroll.y)
            } else {
                setScrollPosition(0, 0)
            }

            document.body.style.height = ``
        }
    })

    swup.hooks.on('history:popstate', () => {
        const historyState = scrollHistory.getCurrent()
        if (historyState) {
            document.body.style.height = `${historyState.height}px`
        }
    })

    window.swup = swup
}
